"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies = __importStar(require("js-cookie"));
var React = __importStar(require("react"));
var tldts_1 = require("tldts");
var modal_1 = __importDefault(require("../../plugins/modal"));
var useState = React.useState, useEffect = React.useEffect;
var tldCookieName = 'tldModalDisplayed';
function TLDRedirectApp(props) {
    var _this = this;
    var disable = true;
    if (disable)
        return null;
    /* To add another country:
     *    1)  add flag to props & theme settings in sections/tld-redirect-modal-app.liquid
     *    2)  add country config to countries config below
     *    3)  add footer flag config in Footer section in settings_schema.json and snippets/footer-flag-links.liquid
     */
    var countries = [
        { image: props.usFlagImg, name: 'US', url: 'https://hellobello.com', tld: 'com' },
        { image: props.canFlagImg, name: 'CA', url: 'https://hellobello.ca', tld: 'ca' },
        { image: props.ukFlagImg, name: 'UK', url: 'https://hellobello.co.uk', tld: 'co.uk' },
        // { image: props.auFlagImg, name: 'AU', url: 'https://hello-bello.com.au', tld: 'com.au' },
    ];
    var _a = __read(useState(false), 2), isModalOpen = _a[0], setIsModalOpen = _a[1];
    var _b = __read(useState([]), 2), countrySelections = _b[0], setCountrySelections = _b[1];
    var _c = __read(useState(), 2), currentTldData = _c[0], setCurrentTldData = _c[1];
    // https://www.geojs.io/docs/v1/endpoints/country/
    var getCountry = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch('https://get.geojs.io/v1/ip/country')];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.text()];
                case 2: return [2 /*return*/, (_a.sent()).trim()]; // needs this because of newline char
                case 3:
                    e_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var openModalAndCookie = function () { return __awaiter(_this, void 0, void 0, function () {
        var tldData, requesterCountry;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // if the cookie is already set, no need to continue
                    if (Cookies.get(tldCookieName))
                        return [2 /*return*/];
                    tldData = (0, tldts_1.parse)(window.location.href);
                    return [4 /*yield*/, getCountry()
                        // we'll need this later
                    ];
                case 1:
                    requesterCountry = _a.sent();
                    // we'll need this later
                    setCurrentTldData(tldData);
                    // if we can't determine the tld or requesters' country, no need to continue
                    if (!tldData || !requesterCountry)
                        return [2 /*return*/];
                    if (
                    // we will want to change this when we add more countries
                    (tldData.publicSuffix === 'com' && requesterCountry !== 'US') ||
                        (tldData.publicSuffix === 'ca' && requesterCountry !== 'CA') ||
                        (tldData.publicSuffix === 'co.uk' && requesterCountry !== 'GB')
                    // (tld === 'com.au' && requesterCountry !== 'AU')
                    ) {
                        setCountrySelections(countries.filter(function (country) {
                            // countrySelections in the pop up modal should show the country site you trying to see and the country we detect you in
                            return tldData.publicSuffix === country.tld || requesterCountry === country.name;
                        }));
                        setIsModalOpen(true);
                    }
                    // set the cookie to whatever so the modal will never show up again during a session
                    Cookies.set(tldCookieName, '1');
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        openModalAndCookie();
    }, []);
    var modalStyles = {
        content: {
            borderRadius: '10px',
            top: '-10%',
        },
    };
    var closeModal = function () { return setIsModalOpen(false); };
    var onFlagClick = function (country) { return function (e) {
        e.preventDefault();
        // if the country clicked is the same as the current one, we can just close this modal
        if (country.tld === (currentTldData === null || currentTldData === void 0 ? void 0 : currentTldData.publicSuffix))
            setIsModalOpen(false);
        // else we'll redirect to the new TLD, keeping all the other url components the same
        else {
            // e.g., https://hb.com/a?1=2 === https://hb.ca/a?1=2
            var newUrl = window.location.protocol + '//' + (currentTldData === null || currentTldData === void 0 ? void 0 : currentTldData.domainWithoutSuffix) + '.' + country.tld + window.location.pathname + window.location.search + window.location.hash;
            document.location.href = newUrl;
        }
        return false;
    }; };
    var countrySelect = countrySelections.map(function (country, i) {
        return (React.createElement("a", { className: 'cell small-6', href: country.url, onClick: onFlagClick(country), key: i },
            React.createElement("img", { alt: country.image, className: 'margin-bottom-1', src: country.image, style: { width: '150px', cursor: 'pointer' } }),
            React.createElement("div", null, country.name)));
    });
    return (React.createElement(modal_1.default, { isOpen: isModalOpen, handleClose: closeModal, style: modalStyles },
        React.createElement("div", { className: 'hide-for-medium padding-vertical-10 padding-horizontal-10 text-center' },
            React.createElement("h4", null, props.titleText),
            React.createElement("div", { className: 'divider bg-hippie-blue', style: { width: '10%', display: 'inline-block' } }),
            React.createElement("div", { className: 'grid-x align-middle grid-margin-x padding-vertical-5' }, countrySelect),
            React.createElement("div", { className: 'text-gray' }, props.bodyText)),
        React.createElement("div", { className: 'show-for-medium padding-vertical-10 padding-horizontal-10 text-center', style: { minHeight: '612px', maxWidth: '788px' } },
            React.createElement("h2", { className: 'padding-top-20' }, props.titleText),
            React.createElement("div", { className: 'divider bg-hippie-blue', style: { width: '56px', height: '8px', display: 'inline-block' } }),
            React.createElement("div", { className: 'grid-x align-middle grid-margin-x padding-vertical-5 padding-horizontal-30 padding-vertical-20' }, countrySelect),
            React.createElement("div", { className: 'padding-vertical-5 padding-horizontal-20' },
                React.createElement("span", { className: 'padding-horizontal-5 text-gray' }, props.bodyText)))));
}
exports.default = TLDRedirectApp;
